import { get } from 'lodash';
import { connect } from 'react-redux';

import { EMPTY_OBJ } from 'Services/constants/empty';
import MeetingInfoWarnings from './component';

export default connect((state) => ({
  ...get(state, ['Meeting', 'meetingState'], EMPTY_OBJ),
}))(MeetingInfoWarnings);
